import React, { createRef } from "react";
import DropdownMenu from "./DropdownMenu";
import { connect } from "react-redux";
import { startLogout } from "../actions/auth";

export class Footer extends React.Component {
    state = {
        showDropdownMenu: false
    };

    handleOnClick = () => {
        this.setState(prevState => ({
            showDropdownMenu: !prevState.showDropdownMenu
        }))
    };

     render() {
        return (
        <footer className="footer">
            <div>  
                <div className="footer__content"> 
                    <div className="footer_text">
                        <p className="copyright">©2023 TrackIt™ Demo, Powered by <a href="https://www.authfx.io/" target="_blank">AuthFX</a>. ALL RIGHTS RESERVED.<span className="breakline">  •  <a href="https://www.authfx.io/terms-of-service/" target="_blank">Terms of Service</a></span><span className="breakline">  •  <a href="https://www.authfx.io/privacy-policy/" target="_blank">Privacy Policy</a></span></p>
                    </div>
                </div>
                
            </div>
                 { this.state.showDropdownMenu ? <div className="content-container right"><DropdownMenu /></div> : null }  
        </footer>
        )
    };
};
  
const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer.js